export const testStageBaseUrls = {
  CORE_BASE_URL: 'https://api-test.risevision.com',
  STORE_BASE_URL: 'https://api-test.risevision.com/store',
  STORAGE_BASE_URL: 'https://api-test.risevision.com/storage',
  VIEWER_BASE_URL: 'https://widgets.risevision.com/viewer-stage-0',
  TEMPLATES_BASE_URL:
    'https://widgets.risevision.com/staging/templates/PRODUCT_CODE',
  SERVICES_BASE_URL: 'https://services-stage.risevision.com',
  SERVICES2_BASE_DOMAIN: 'services2-stage.risevision.com',
};

export const prodBaseUrls = {
  CORE_BASE_URL: 'https://api.risevision.com',
  STORE_BASE_URL: 'https://api.risevision.com/store',
  STORAGE_BASE_URL: 'https://api.risevision.com/storage',
  VIEWER_BASE_URL: 'https://widgets.risevision.com/viewer',
  TEMPLATES_BASE_URL:
    'https://widgets.risevision.com/stable/templates/PRODUCT_CODE',
  SERVICES_BASE_URL: 'https://services.risevision.com',
  SERVICES2_BASE_DOMAIN: 'services2.risevision.com',
};

export const betaBaseUrls = {
  CORE_BASE_URL: 'https://api.risevision.com',
  STORE_BASE_URL: 'https://api.risevision.com/store',
  STORAGE_BASE_URL: 'https://api.risevision.com/storage',
  VIEWER_BASE_URL: 'https://widgets.risevision.com/viewer',
  TEMPLATES_BASE_URL:
    'https://widgets.risevision.com/staging/templates/PRODUCT_CODE',
  SERVICES_BASE_URL: 'https://services.risevision.com',
  SERVICES2_BASE_DOMAIN: 'services2.risevision.com',
};
